import script from "./indexAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexAlert.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__